import { getCurrentHubDomain } from 'utils/studioConfig';

function getPath(name, type) {
	if (type === 'movie') {
		if (name === 'all') {
			return `cms/movies/all/`; // endpoint for fetching all movies
		}

		return `cms/movies/slugs/${name}.json`; // endpoint for fetching individual movie by slug
	}

	return `cms/${type}s/${name}.json`; // endpoint for fetching sections and other types of data
}

export async function getHubData(name, type) {
	const domainName = getCurrentHubDomain();
	if (!domainName) return Promise.reject(new Error('No hub domain found for current region'));

	const url = new URL(getPath(name, type), `https://${domainName}`);

	const res = await fetch(url, { cache: 'no-cache' });
	if (!res.ok) {
		throw new Error(`Data unavailable for ${name}`);
	}
	return await res.json();
}
